import React, { useState, useEffect } from 'react';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import { host_url } from '../../App';
import '../ListenSubpage.css';
import '../speiseplan/SpeiseplanVerwaltung.css';
import './EssensreihenfolgeVerwaltung.css';

const WOCHENTAGE = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

const MAHLZEITEN = [
  { key: 'Fruehstueck', label: 'Frühstück',  icon: 'bakery_dining' },
  { key: 'Abendessen',  label: 'Abendessen', icon: 'dinner_dining' },
];

function getHeutigerWochentag() {
  const jsTag = new Date().getDay();
  return WOCHENTAGE[jsTag === 0 ? 6 : jsTag - 1];
}

function EssensreihenfolgeVerwaltung() {
  const [tag, setTag] = useState(getHeutigerWochentag());
  const [successMsg, setSuccessMsg] = useState('');

  // Listen pro Mahlzeit für den gewählten Tag, plus Dirty-Flag und Eingabefeld
  const [listen, setListen] = useState({});
  const [dirty, setDirty] = useState({});
  const [neueZelte, setNeueZelte] = useState({});

  const fetchDaten = async (wochentag) => {
    try {
      const res = await fetch(`${host_url}/essensreihenfolge`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const neueListen = {};
      MAHLZEITEN.forEach(({ key }) => {
        neueListen[key] = (Array.isArray(data) ? data : [])
          .filter((e) => e.Wochentag === wochentag && e.Mahlzeit === key)
          .sort((a, b) => a.Position - b.Position)
          .map((e) => e.Zelt);
      });
      setListen(neueListen);
      setDirty({});
      setNeueZelte({});
    } catch (err) {
      console.error('Fehler beim Laden der Essensreihenfolge:', err);
      setListen({});
    }
  };

  useEffect(() => {
    fetchDaten(tag);
  }, [tag]);

  const updateListe = (mahlzeit, neueListe) => {
    setListen((prev) => ({ ...prev, [mahlzeit]: neueListe }));
    setDirty((prev) => ({ ...prev, [mahlzeit]: true }));
  };

  const verschiebe = (mahlzeit, index, richtung) => {
    const liste = [...(listen[mahlzeit] || [])];
    const ziel = index + richtung;
    if (ziel < 0 || ziel >= liste.length) return;
    [liste[index], liste[ziel]] = [liste[ziel], liste[index]];
    updateListe(mahlzeit, liste);
  };

  const entferne = (mahlzeit, index) => {
    const liste = [...(listen[mahlzeit] || [])];
    liste.splice(index, 1);
    updateListe(mahlzeit, liste);
  };

  const fuegeHinzu = (mahlzeit) => {
    const zelt = (neueZelte[mahlzeit] || '').trim();
    if (!zelt) return;
    updateListe(mahlzeit, [...(listen[mahlzeit] || []), zelt]);
    setNeueZelte((prev) => ({ ...prev, [mahlzeit]: '' }));
  };

  const handleSave = async (mahlzeit) => {
    try {
      const res = await fetch(`${host_url}/essensreihenfolge`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          Wochentag: tag,
          Mahlzeit: mahlzeit,
          Zelte: listen[mahlzeit] || [],
        }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSuccessMsg('Reihenfolge gespeichert!');
      setDirty((prev) => ({ ...prev, [mahlzeit]: false }));
    } catch (err) {
      console.error('Fehler beim Speichern:', err);
      alert('Fehler beim Speichern. Bitte prüfe, ob das Backend erreichbar ist.');
    }
  };

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/listen" />
        <h1 className="section-title blue">Essensreihenfolge</h1>
        <p className="reihenfolge-admin-hinweis">
          Reihenfolge, in der die Zelte zum Essen gerufen werden – gilt nur für
          Frühstück und Abendessen.
        </p>

        {/* Wochentag-Tabs */}
        <div className="speiseplan-admin-tabs">
          {WOCHENTAGE.map((wochentag) => (
            <button
              key={wochentag}
              className={`speiseplan-admin-tab ${tag === wochentag ? 'active' : ''}`}
              onClick={() => setTag(wochentag)}
            >
              {wochentag.substring(0, 2)}
            </button>
          ))}
        </div>

        <div className="meal-admin-cards" key={tag}>
          {MAHLZEITEN.map(({ key, label, icon }) => {
            const liste = listen[key] || [];
            return (
              <div className="meal-admin-card" key={key}>
                <div className="meal-admin-card-header">
                  <span className="material-symbols-outlined">{icon}</span>
                  <h3>{label}</h3>
                </div>

                {liste.length === 0 ? (
                  <p className="meal-admin-empty">Noch keine Zelte in der Liste.</p>
                ) : (
                  <ol className="reihenfolge-admin-liste">
                    {liste.map((zelt, index) => (
                      <li key={`${zelt}-${index}`}>
                        <span className="reihenfolge-admin-position">{index + 1}.</span>
                        <span className="reihenfolge-admin-zelt">{zelt}</span>
                        <span className="reihenfolge-admin-buttons">
                          <button
                            title="Nach oben"
                            disabled={index === 0}
                            onClick={() => verschiebe(key, index, -1)}
                          >
                            <span className="material-symbols-outlined">arrow_upward</span>
                          </button>
                          <button
                            title="Nach unten"
                            disabled={index === liste.length - 1}
                            onClick={() => verschiebe(key, index, 1)}
                          >
                            <span className="material-symbols-outlined">arrow_downward</span>
                          </button>
                          <button
                            title="Entfernen"
                            className="reihenfolge-admin-entfernen"
                            onClick={() => entferne(key, index)}
                          >
                            <span className="material-symbols-outlined">close</span>
                          </button>
                        </span>
                      </li>
                    ))}
                  </ol>
                )}

                <div className="reihenfolge-admin-hinzufuegen">
                  <input
                    type="text"
                    placeholder="Zelt hinzufügen, z.B. Tom & Jerry"
                    value={neueZelte[key] || ''}
                    onChange={(e) =>
                      setNeueZelte((prev) => ({ ...prev, [key]: e.target.value }))
                    }
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') fuegeHinzu(key);
                    }}
                  />
                  <button className="btn-save" onClick={() => fuegeHinzu(key)}>
                    <span className="material-symbols-outlined">add</span>
                  </button>
                </div>

                <div className="meal-admin-card-actions">
                  <button
                    className="btn-save"
                    onClick={() => handleSave(key)}
                    disabled={!dirty[key]}
                  >
                    <span className="material-symbols-outlined">save</span>
                    Speichern
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {successMsg && (
          <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
        )}
      </div>
    </KernteamLayout>
  );
}

export default EssensreihenfolgeVerwaltung;
